import { render } from "./EnrollmentImport.vue?vue&type=template&id=530ab7fc&scoped=true"
import script from "./EnrollmentImport.vue?vue&type=script&lang=js"
export * from "./EnrollmentImport.vue?vue&type=script&lang=js"

import "./EnrollmentImport.vue?vue&type=style&index=0&id=530ab7fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530ab7fc"]])

export default __exports__